// Refresco por eventos del tiempo real (/rt) en lugar de preguntar al servidor cada pocos segundos. Cuando 3CX avisa
// que una llamada termino (o se perdio), su registro llega al CRM unos segundos despues: se refrescan las llamadas
// (y con ellas los contadores del menu y de Hoy) a los 3 s y otra vez a los 25 s. Varios avisos seguidos se juntan.
import type { QueryClient } from '@tanstack/react-query';

type Aviso = { tipo: string; [k: string]: unknown };

export const ESPERAS_LLAMADA = [3_000, 25_000];

export const terminoLlamada = (e: Aviso) => {
  if (e.tipo !== 'llamada3cx') return false;
  const estado = (e.llamada as { estado?: unknown } | undefined)?.estado;
  return estado === 'terminada' || estado === 'perdida';
};

export function refrescoPorEventos(qc: Pick<QueryClient, 'invalidateQueries'>, esperas = ESPERAS_LLAMADA) {
  const pendientes = new Map<number, ReturnType<typeof setTimeout>>();
  const alAviso = (e: Aviso) => {
    if (!terminoLlamada(e)) return;
    for (const ms of esperas) {
      if (pendientes.has(ms)) continue;
      pendientes.set(
        ms,
        setTimeout(() => {
          pendientes.delete(ms);
          void qc.invalidateQueries({ queryKey: ['llamadas'] });
        }, ms),
      );
    }
  };
  const parar = () => {
    for (const t of pendientes.values()) clearTimeout(t);
    pendientes.clear();
  };
  return { alAviso, parar };
}
